import React from "react";
import Table from "../table/table";

import { BASE_URL } from "../../config";
import FileIcon from "../svgs/fileIcon";
import { humanFileSize } from "../../constants/misc";

const TABLE_HEADER = [
  {
    title: "FILENAME",
  },
  {
    title: "OPERATIONS",
  },
];

const FileTable = (props) => {
  const { files, rowProps, loading } = props;
  if (files && files.length > 0) {
    return (
      <Table
        header={TABLE_HEADER}
        cellsNumber={2}
        rows={files}
        rowProps={rowProps}
        RenderRow={RenderTableRow}
      />
    );
  } else if (((files && files.length === 0) || !files) && !loading) {
    return <span>There are no files yet.</span>;
  } else {
    return null;
  }
};

const RenderTableRow = (props) => {
  const { fileName, fileSize, url, uuid, onRemove } = props;

  const handleDownload = (event) => {
    event.preventDefault();

    // Check if URL is a data URL (contains base64)
    if (url && url.startsWith("data:")) {
      // Create a download link for the base64 data
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName || "download";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      // For regular URLs, open in new tab
      window.open(BASE_URL + url, "_blank");
    }
  };

  return (
    <li className="row line">
      <div className="cell forum" data-title="FILENAME">
        <div className="arr_line_1">
          <a href="#" onClick={handleDownload}>
            <FileIcon
              style={{
                maxWidth: 15,
                marginRight: 8,
                fill: "white",
                verticalAlign: "bottom",
              }}
            />

            {fileName}
          </a>
        </div>
      </div>
      <div className="cell tr_white posts" data-title="OPERATIONS">
        <a href="#" onClick={handleDownload}>
          DOWNLOAD
        </a>
        <span> / </span>
        {onRemove && (
          <a
            href="#"
            onClick={(event) => {
              event.preventDefault();
              onRemove(uuid);
            }}
          >
            REMOVE
          </a>
        )}
      </div>
    </li>
  );
};

export default FileTable;
